import { IconPropsType } from '..';

export const ImageIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.75 16.25C3.3375 16.25 2.98438 16.1031 2.69063 15.8094C2.39687 15.5156 2.25 15.1625 2.25 14.75V4.25C2.25 3.8375 2.39687 3.48438 2.69063 3.19063C2.98438 2.89687 3.3375 2.75 3.75 2.75H14.25C14.6625 2.75 15.0156 2.89687 15.3094 3.19063C15.6031 3.48438 15.75 3.8375 15.75 4.25V14.75C15.75 15.1625 15.6031 15.5156 15.3094 15.8094C15.0156 16.1031 14.6625 16.25 14.25 16.25H3.75ZM3.75 14.75H14.25V4.25H3.75V14.75ZM5.25 13.25H12.75C12.9 13.25 13.0125 13.1813 13.0875 13.0438C13.1625 12.9062 13.15 12.775 13.05 12.65L10.9875 9.89375C10.9125 9.79375 10.8125 9.74375 10.6875 9.74375C10.5625 9.74375 10.4625 9.79375 10.3875 9.89375L8.4375 12.5L7.05 10.6438C6.975 10.5438 6.875 10.4938 6.75 10.4938C6.625 10.4938 6.525 10.5438 6.45 10.6438L4.95 12.65C4.85 12.775 4.8375 12.9062 4.9125 13.0438C4.9875 13.1813 5.1 13.25 5.25 13.25Z"
      fill="currentColor"
    />
  </svg>
);
